// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__Z8ltM","actions":"GroupTable_actions__pZXyZ","deleteModalFooter":"GroupTable_deleteModalFooter__2HKQX"};